"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultedOutfit = void 0;
const Item_1 = require("../../classes/Item");
const Outfit_1 = require("../../classes/Outfit");
const definables_1 = require("definables");
const state_1 = require("../../state");
const getDefaultedOutfit = (outfitItemID) => {
    if (state_1.state.values.defaultOutfitID === null) {
        throw new Error("defaultOutfitID does not exit");
    }
    if (typeof outfitItemID !== "undefined") {
        return (0, definables_1.getDefinable)(Item_1.Item, outfitItemID).outfit;
    }
    return (0, definables_1.getDefinable)(Outfit_1.Outfit, state_1.state.values.defaultOutfitID);
};
exports.getDefaultedOutfit = getDefaultedOutfit;
